if ( window.diaporama_image_js === undefined) {
    window.diaporama_image_js = true;

	// Resize des images portrait dans le contenu charge
	function resizePortraitImg() {
		// Diaporama partie principale
		if($(".diaporama_images")) {
			$(".diaporama_images").each(function(){
				var fired = false;
				if (fired == false) {
					if($(".image_pop").is(":visible")) {
						let img_paysage_height = $(".diaporama_images .reveal .slick-slide img.img_paysage").height();
						$(".diaporama_images .reveal .slick-slide img.img_portrait:visible").css({"height" : img_paysage_height});
					} else {
						if ($(".img_paysage").attr('src')) {
							let img_paysage_height = $(".diaporama_images .slick-slide img.img_paysage").height();
							$(".diaporama_images .slick-slide img.img_portrait").css({"height" : img_paysage_height});
						}
					}
					var fired = false;
				}
			});
		}
	}

	// function load_visible_slide_img() {
		// setTimeout(function(){

		// Load first slide + thumbnails
		/*$(".slider-for-images .slick-current, .slider-nav-images").find("img").addClass("lazy");
		animate();
		resizePortraitImg();*/

		// }, 100);
	// }

	$(document).bind('_js_ready popin', function() {

		// Config
		var fired = false;
		function initSlick() {
			$('.diaporama_images').each( function(index) {
				let sliderForImages = $(this).children('.contenu_bloc').children('.slider-for-images');

				// Compteur de slide
					let uid = $(this).closest('.diaporama_images').attr('data-uid');
					let counter = $('#slide_counter_' + uid);
					sliderForImages.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
						//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
						let i = (currentSlide ? currentSlide : 0) + 1;
						counter.html('<p><span class="count_current">' + i + '</span> / <span class="count_total">' + slick.slideCount + '</span>');
					});

				sliderForImages.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
	  				centerMode: true,
	  				centerPadding: 0,
					infinite: true,
					arrows: true,
					// ///////// Conf pour arrow prev / next
					prevArrow:"<button type='button' aria-label='Précédent' title='Précédent' class='slick-prev slick-arrow'><span class='show-for-sr'>Précédent</span></button>",
					nextArrow:"<button type='button' aria-label='Suivant' title='Suivant' class='slick-next slick-arrow'><span class='show-for-sr'>Suivant</span></button>",
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
							}
						},
						{
							breakpoint: 640,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
				});
				let nb_slides = $(this).find('.slick-slide:not(.slick-cloned)').length;
				if (nb_slides <= 3) {
					$(this).find('.slick-slider').addClass('no-slick');
				    $(this).find('.slick-current').addClass('slick-is-visible').removeClass('slick-current');
				    $(this).find('.slick-slide:not(.slick-current):not(.slick-cloned)').addClass('slick-is-visible');
					$(this).find('.slide_counter .count_current').text(nb_slides);
				}
				resizePortraitImg();
			});

			var idClicked;
			$(".diaporama_images .slider-for-images .slick-slide a").on('click',function(e){
				idClicked = $(this).data('id');
			});

			$('.image_pop').on('open.zf.reveal',function(){
				$("#main").css({"z-index": "inherit"});
				$(this).parents(".diaporama_images").addClass("activePop");
				$(this).parents(".diaporama_images").children(".reveal_container_content").addClass("open");
				$('.diaporama_images.activePop .slider-for-images-pop').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: true,
					// ///////// Conf pour arrow prev / next
					prevArrow:"<button type='button' aria-label='Précédent' title='Précédent' class='slick-prev slick-arrow'><span class='show-for-sr'>Précédent</span></button>",
					nextArrow:"<button type='button' aria-label='Suivant' title='Suivant' class='slick-next slick-arrow'><span class='show-for-sr'>Suivant</span></button>",
					fade: true,
					focusOnSelect: true,
					initialSlide : idClicked,
					asNavFor: '.diaporama_images.activePop .slider-for-images'
				});

				$(this).children(".wrap_popin").children(".slider-for-images-pop").children(".slick-arrow").attr("tabindex", "0");

				// Load first slide image
				$(".image_pop .slick-current img").addClass("lazy");
				loadNextImg();
				animate();
				resizePortraitImg();

				// Hide things
				$('#header').addClass('hide');
				if($("#popin_detail")) {
					$("#first_display .wrap_arrow").addClass("hide");
				}
			});

			$('.image_pop').on('closed.zf.reveal',function(){
				$("#main").css({"z-index": "1"});
				$(this).parents(".diaporama_images").children(".reveal_container_content").removeClass("open");
				var current_slick_slide = $(this).children(".wrap_popin").children(".slick-slider").children(".slick-list").children(".slick-track").children(".slick-current").children(".bloc_image_diapo").data('id');
				//console.log(current_slick_slide);
				$('.diaporama_images.activePop .slider-for-images-pop').slick('unslick');
				$('.diaporama_images.activePop .slick-slider').slick('refresh');
				$(this).parents(".diaporama_images").removeClass("activePop");
				//resizePortraitImg();

				// Show things
				$('#header').removeClass('hide');
				if($("#popin_detail")) {
					$("#first_display .wrap_arrow").removeClass("hide");
				}
			});

			fired = true;
		}

		if (fired == false) {initSlick();}
		// Resize des images portrait
		// load_visible_slide_img();
		// resizePortraitImg();
		//resizePortraitImgpopin();

		// Lazy load
		function loadNextImg() {
			$('.diaporama_images .slick-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
				// $(this).find(".slick-slide[aria-hidden='true'] img").addClass("lazy");
				$(this).find(".slick-current img, .slick-active + .slick-slide[aria-hidden='true'] img").addClass("lazy");
				loadPrevImg();
				animate();
				resizePortraitImg();
			});
		}
		function loadPrevImg() {
			$(".slider-for-images").find(".slick-current").prev(".slick-slide").find("img").addClass("lazy");
		}

		loadPrevImg();
		loadNextImg();

		// Bugfix open reveal on keydown
		$('.diaporama_images .slider-for-images a').on('keypress', function() {
			var reveal_id = $(this).attr("data-open");
			$('#' + reveal_id).foundation('open');
		});

		// Refresh des slick slider à l'ouverture des éléments type popin
		$('.reveal').on('open.zf.reveal',function(){
			$('.slick-track:eq(0) .slick-active.slick-current img').one( '_js_load', function() {
				$('.slick-slider.slick-initialized').slick('refresh');
			}).each( function() {
				if( this.complete ) $( this ).trigger( '_js_load' );
			});
			resizePortraitImg();
			//loadNextImg();
		});

		// SMALL - DIAPORAMA IMAGES POPIN
		if( (Foundation.MediaQuery.current == "small")) {
			$('.image_pop').on("open.zf.reveal", function(){
				$('#header').addClass('hide');
			});

			$('.image_pop').on("closed.zf.reveal", function(){
				$('#header').removeClass('hide');
			});
		}
	});

	$(document).on('load', function () {
		resizePortraitImg();
	});

	$(window).resize(function() {
		resizePortraitImg();
	});

	$(window).scroll(function() {
	// 	load_visible_slide_img();
		resizePortraitImg();
	});

	// if($('#popin_detail')) {
	// 	$('#popin_detail').on('open.zf.reveal',function(){
	// 		$("#popin_detail").scroll(function() {
	// 			load_visible_slide_img();
	// 			//console.log("scroll");
	// 		});
	// 		$("#popin_detail").parent(".reveal-overlay").scroll(function() {
	// 			load_visible_slide_img();
	// 			//console.log("scroll");
	// 		});
	// 	});
	// }
}